import TagManager from 'react-gtm-module';
import { config } from '../config';

export const initGTM = () => {
    const { gtmId, environment } = config;

    // Initialize GTM only in the production environment
    if (environment !== 'production') {
        return;
    }

    // Do not initialize GTM if gtmId is not provided
    if (!gtmId) {
        console.warn('GTM ID is not configured for this environment.');
        return;
    }

    // Avoid re-initializing GTM if it's already been initialized
    if (window.google_tag_manager) {
        return;
    }

    try {
        TagManager.initialize({ gtmId });
        console.log('GTM initialized successfully');
    } catch (error) {
        console.error('Failed to initialize GTM:', error);
    }
};
